import { render, staticRenderFns } from "./RedisManager.vue?vue&type=template&id=350bc01d"
import script from "./RedisManager.vue?vue&type=script&lang=js"
export * from "./RedisManager.vue?vue&type=script&lang=js"
import style0 from "./RedisManager.vue?vue&type=style&index=0&id=350bc01d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports